module.exports = __webpack_public_path__ + "static/media/join_our_community_video.95dddb34.webp";